// develop
export const ENV_DEVELOP = 'development';
// staging
export const ENV_STAGING = 'staging';
// production
export const ENV_PRODUCTION = 'production';

/**
 * networkVersion アプリバージョン
 */
// apiIfVer = networkVersion
export const SERVER_VERSION = '1.0.0';
// webVer = アプリバージョン
export const APP_VERSION = '1.0.0';

// 未対応
export const RECIPROCAL = '1';
// 対応済
export const NONRECIPROCAL = '2';

// 担当者
export const MANAGER = 'manager';

// 対応者
export const MEMBER = 'member';

// ROOM STATUS
export const ROOM_OFFLINE = 0;
export const ROOM_ONLINE = 1;
export const ROOM_AFK = 2;
export const ROOM_CALLING = 3;
export const ROOM_TALKING = 4;

// MEMO STATUS
export const MEMO_TEMP = 0;
export const MEMO_CONFIRM = 1;
export const MEMO_TODO_OPEN = 2;
export const MEMO_TODO_CLOSE = 3;

// WINDWOS SIZE
export const FULLHD_HOST_HEADER = 85;
export const FULLHD_HOST_CONTENT_WIDTH = 1294;
export const FULLHD_HOST_CONTENT_HEIGHT = 823;
export const FULLHD_HOST_INNER_CONTENT_WIDTH = 714;
export const FULLHD_HOST_INNER_CONTENT_HEIGHT = 714;
export const FULLHD_HOST_INNER_CONTENT_SIDE_WIDTH = 250;
export const FULLHD_HOST_SELF_WIDTH = 250;

export const FULLHD_GUEST_CONTENT_WIDTH = 823;
export const FULLHD_GUEST_CONTENT_HEIGHT = 823;
export const FULLHD_GUEST_INNER_CONTENT_WIDTH = 760;
export const FULLHD_GUEST_INNER_CONTENT_HEIGHT = 760;
export const FULLHD_GUEST_SELF_WIDTH = 250;

export const FULLHD_NAVI_HEIGHT = 121;

// CALL STATUS
export const CALL_STATUS_CATCH = 0;
export const CALL_STATUS_SKIP = 1;

// PLANS
export const PLANS = [
	{ id: 0, name: 'スタートアッププラン' },
	{ id: 1, name: 'ビジネスプラン' },
	{ id: 2, name: 'プロフェッショナルプラン' }
];

// ボタン表示位置
export const BTN_POSTIONS = [
	{ id: 0, name: '左' },
	{ id: 1, name: '中間' },
	{ id: 2, name: '右' }
];